import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { showToast } from '../../store/features/toastSlice';
export function useShowToast() {
  const dispatch = useDispatch();
  const show = useCallback(_ref => {
    let {
      message,
      variant
    } = _ref;
    dispatch(showToast({
      message,
      variant
    }));
  }, [dispatch]);
  return show;
}